import { render } from "./BoqItemsPrint.vue?vue&type=template&id=c782176e&scoped=true"
import script from "./BoqItemsPrint.vue?vue&type=script&lang=js"
export * from "./BoqItemsPrint.vue?vue&type=script&lang=js"

import "./BoqItemsPrint.vue?vue&type=style&index=0&id=c782176e&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c782176e"]])

export default __exports__